import {FC} from "react";
import {Container, useTheme, Grid, Box, Typography} from "@mui/material";
import BrickGrey from "shared/assets/img/brick-grey.png";

export const PublicFooter: FC = () => {
  const theme = useTheme();

  return (
    <footer>
    <Container maxWidth='xl' sx={{padding:'10px'}}>
      <Grid
        sx={{
          backgroundColor: theme.palette.text.primary,
          padding: "10px",
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
        container>
        <Grid item sx={{height: '37px'}}>
          <Box
            component="img"
            src={BrickGrey}
            sx={{
              width: `37px`,
            }}
          />
        </Grid>
        <Grid item>
          <Typography
            sx={{
              color: theme.palette.background.default,
              fontSize: '18px',
              lineHeight: '25px'
          }}>
            ©&nbsp;mix bricks&nbsp;2025
          </Typography>
        </Grid>
        <Grid item sx={{height: '37px'}}>
          <Box
            component="img"
            src={BrickGrey}
            sx={{
              width: `37px`,
            }}
          />
        </Grid>
      </Grid>
    </Container>
    </footer>
  )
}
